import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
  LexicalEditor,
  createCommand,
} from 'lexical';
import { $fixTextNodeSelection } from 'modules/Lexical/helpers/fixTextNodeSelection';
import { $createProjectMetadataTokenNode } from '../../nodes/ProjectMetadataTokenNode';

export const PROJECT_METADATA_COMMAND = {
  INSERT_TOKEN: createCommand<string>(),
} as const;

export function registerCommands(
  editor: LexicalEditor,
  metadata: Record<string, string>,
): () => void {
  return editor.registerCommand(
    PROJECT_METADATA_COMMAND.INSERT_TOKEN,
    (tokenKey) => {
      const selection = $getSelection();
      if (!$isRangeSelection(selection)) {
        return false;
      }

      const textTokenNode = $createProjectMetadataTokenNode(tokenKey, metadata);

      if (!textTokenNode) {
        return false;
      }

      const selectionStyleObject = selection.style;
      textTokenNode.setStyle(selectionStyleObject);

      selection.insertNodes([textTokenNode]);
      $fixTextNodeSelection(textTokenNode);

      return true;
    },
    COMMAND_PRIORITY_EDITOR,
  );
}
